module.exports = __webpack_public_path__ + "img/a55d459.png";